import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { User } from '@/shared/types/auth'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Usuarios que pueden actualizar reportes y, por tanto, ver el indicador "Actualizado":
 * superusuarios y los grupos `admin` (antes Tonal_admin) y `mailing_admin`.
 */
export function canUpdateReports(user?: User | null): boolean {
  return !!(
    user?.is_superuser ||
    user?.groups?.includes('admin') ||
    user?.groups?.includes('mailing_admin')
  )
}
